import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Injectable } from '@angular/core';
import {
  Contabilidad,
  ContabilidadResponse,
} from '@p-p-portafolio/promociones/interfaces/contabilidad';
import { environment } from 'src/environments/environment';
import { Capitales } from '@p-p-portafolio/promociones/interfaces/capitales';
import { EntityOperationResult } from '@shared/interfaces/responses/entity-operation-result';
import { UntypedFormControl, UntypedFormGroup, Validators } from '@angular/forms';
import {
  MovimientoCaja,
  MovimientoCajaResponse,
} from '@p-p-portafolio/interfaces/movimientoCaja';
import { Estatus } from '@p-p-portafolio/interfaces/estatus';
import { Observable } from 'rxjs';

@Injectable({
  providedIn: 'root',
})
export class ContabilidadService {
  private baseUrl = environment.apiBaseUrl + 'api/promociones/contabilidad';

  constructor(private http: HttpClient) {}

  form: UntypedFormGroup = new UntypedFormGroup({
    let_origen: new UntypedFormControl(null, [Validators.required]),
    let_tipomov: new UntypedFormControl('', [Validators.maxLength(40)]),
    sPromocion: new UntypedFormControl(null),
    iOrigen: new UntypedFormControl(null),
    iTipoMov: new UntypedFormControl(null),
    iConcepto: new UntypedFormControl('', [Validators.maxLength(40)]),
    iSubConcepto: new UntypedFormControl('', [Validators.maxLength(40)]),
    sCuenta: new UntypedFormControl(null),
    sContra: new UntypedFormControl(null),
    sTablaCuenta: new UntypedFormControl(null),
    sTablaContra: new UntypedFormControl(null),
    sCuenta12: new UntypedFormControl(null),
    sContra12: new UntypedFormControl(null),
    sTablaCuenta12: new UntypedFormControl(null),
    sTablaContra12: new UntypedFormControl(null),
    vCuenta: new UntypedFormControl(null),
    vContra: new UntypedFormControl(null),
  });

  initializeFormGroup() {
    this.form.setValue({
      let_origen: null,
      let_tipomov: '',
      sPromocion: null,
      iOrigen: null,
      iTipoMov: null,
      iConcepto: '',
      iSubConcepto: '',
      sCuenta: null,
      sContra: null,
      sTablaCuenta: null,
      sTablaContra: null,
      sCuenta12: null,
      sContra12: null,
      sTablaCuenta12: null,
      sTablaContra12: null,
      vCuenta: null,
      vContra: null,
    });
  }

  populateForm(entity: Contabilidad) {
    this.form.setValue(entity);
  }

  getAll(promocion: string) {
    const url = `${this.baseUrl}/${promocion}`;
    return this.http.get<Contabilidad[]>(url);
  }

  getById(entity: Contabilidad) {
    const httpOptions = {
      headers: new HttpHeaders({
        'Content-Type': 'application/json',
      }),
    };

    const url = `${this.baseUrl}/cuenta-contable`;
    return this.http.post<EntityOperationResult>(url, entity, httpOptions);
  }

  add(entity: Contabilidad) {
    const httpOptions = {
      headers: new HttpHeaders({
        'Content-Type': 'application/json',
      }),
    };
    console.log(entity);
    const url = `${this.baseUrl}/add`;
    return this.http.post<EntityOperationResult>(url, entity, httpOptions);
  }

  update(entity: Contabilidad) {
    const httpOptions = {
      headers: new HttpHeaders({
        'Content-Type': 'application/json',
      }),
    };
    const url = `${this.baseUrl}/upd`;
    return this.http.put<EntityOperationResult>(url, entity, httpOptions);
  }

  delete(entity: Estatus) {
    const url = `${this.baseUrl}/del`;
    return this.http.request<EntityOperationResult>('delete', url, {
      body: entity,
    });
  }

  eliminar(model: Contabilidad): Observable<Response> {
    const url = `${this.baseUrl}/del`;
    return this.http.request<Response>('delete', url, {
      body: model,
    });
  }
}
